module.exports = __webpack_public_path__ + "static/media/imersaoreact.04b63236.svg";